module.exports = __webpack_public_path__ + "img/ic_fluent_link_square_20_regular.795bb11d.svg";